module.exports = __webpack_public_path__ + "static/media/L1020236 1.bd622fe6.svg";